import humanizeDuration from 'humanize-duration'

export function humanDate(dateString) {
  return formatHumanDate(dateString, { short: false })
}

export function humanDateShort(dateString) {
  return formatHumanDate(dateString, { short: true })
}

export function humanizeSeconds(seconds) {
  const options = {
    largest: 2,
    round: true,
    units: ['d', 'h', 'm'],
  }
  return humanizeDuration(seconds * 1000, options)
}

export function timezoneAbbreviation(tz) {
  const parts = tz.split(' ')
  let abbrev = ''
  for (const element of parts) {
    abbrev += element.charAt(0).toUpperCase()
  }
  if (parts.length === 1) {
    return tz
  }
  return abbrev
}

function formatHumanDate(dateString, { short }) {
  if (!dateString) {
    return '-'
  }

  const parsed = parseDatePreservingCalendarDay(dateString)
  if (Number.isNaN(parsed.getTime())) {
    return String(dateString)
  }

  const includeDate = hasExplicitDate(dateString)
  const includeTime = hasExplicitTime(dateString)
  const formatter = new Intl.DateTimeFormat(
    'en-US',
    getFormatOptions({ includeDate, includeTime, short })
  )

  return formatter.format(parsed)
}

function getFormatOptions({ includeDate, includeTime, short }) {
  if (includeDate && includeTime) {
    return {
      day: '2-digit',
      hour: 'numeric',
      hour12: true,
      minute: '2-digit',
      month: short ? 'short' : 'long',
      second: '2-digit',
      weekday: short ? 'short' : 'long',
      year: 'numeric',
    }
  }

  if (includeDate) {
    return {
      day: '2-digit',
      month: short ? 'short' : 'long',
      weekday: short ? 'short' : 'long',
      year: 'numeric',
    }
  }

  return {
    hour: 'numeric',
    hour12: true,
    minute: '2-digit',
    second: '2-digit',
  }
}

function hasExplicitDate(value) {
  const source = String(value || '').trim()
  if (!source) {
    return false
  }

  return (
    /\d{4}-\d{1,2}-\d{1,2}/.test(source) ||
    /\d{1,2}\/\d{1,2}\/\d{2,4}/.test(source)
  )
}

function hasExplicitTime(value) {
  const source = String(value || '').trim()
  if (!source) {
    return false
  }

  return /\d{1,2}:\d{2}/.test(source)
}

function isIsoDateOnly(value) {
  const source = String(value || '').trim()
  return /^\d{4}-\d{2}-\d{2}$/.test(source)
}

function parseDatePreservingCalendarDay(value) {
  const source = String(value || '').trim()
  if (isIsoDateOnly(source)) {
    const [year, month, day] = source.split('-').map(Number)
    return new Date(year, month - 1, day)
  }

  return new Date(source)
}
